import { defineAction } from '~/prix'
import { z } from 'zod'
import geoSynchronizeOltpGeoAction from './geoSynchronizeOltpGeo.action.json' with { type: 'json' }

const syncStatSchema = z.object({
  entity: z.string(),
  scope: z.enum(['global', 'municipality']),
  mode: z.enum(['incremental', 'scopedRefresh']),
  municipalityId: z.number().nullable(),
  updatedAfter: z.string().nullable(),
  pages: z.number(),
  processed: z.number(),
  inserted: z.number(),
  updated: z.number(),
  unchanged: z.number(),
})

const geoSynchronizeOltpGeoDefinition = defineAction({
  ...geoSynchronizeOltpGeoAction,

  input: z.object({
    debug: z.boolean().optional(),
    forceFullRefresh: z.boolean().optional(),
    municipalityIds: z.array(z.number().int()).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    municipalities: z.array(z.number().int()),
    skippedEntities: z.array(z.string()),
    stats: z.array(syncStatSchema),
  }),
})

export default geoSynchronizeOltpGeoDefinition
